import React from "react";
import * as styles from "./OfficeSwitch.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import Link from "@app/components/Link";

const OfficeSwitch = ({ label, link, className }) => {
	const officeSwitchClassName = classNames({
		[styles["office-switch"]]: true,
		[className]: !!className,
	});

	return (
		<div className={officeSwitchClassName}>
			<p className={"font-bold"}>{label}</p>
			<Link href={link} icon={"edit"} label={"Niederlassung wechseln"} />
		</div>
	);
};

OfficeSwitch.propTypes = {
	label: PropTypes.string,
	link: PropTypes.string,
};

export default OfficeSwitch;
